export function getTemplateInfo(t, template_name) {
    let cardTitle;
    let helpTexts;

    switch (template_name) {
        case "class_info_mail":
            cardTitle = t("settings.mail.templates.class_info_mail.title");
            helpTexts = {
                subject: t(
                    "settings.mail.templates.class_info_mail.help_subject",
                ),
                title: t("settings.mail.templates.class_info_mail.help_title"),
                description: t(
                    "settings.mail.templates.class_info_mail.help_description",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                content: t(
                    "settings.mail.templates.class_info_mail.help_content",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                comments: t(
                    "settings.mail.templates.class_info_mail.help_comments",
                ),
            };
            break;
        case "event_info_mail":
            cardTitle = t("settings.mail.templates.event_info_mail.title");
            helpTexts = {
                subject: t(
                    "settings.mail.templates.event_info_mail.help_subject",
                ),
                title: t("settings.mail.templates.event_info_mail.help_title"),
                description: t(
                    "settings.mail.templates.event_info_mail.help_description",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                content: t(
                    "settings.mail.templates.event_info_mail.help_content",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                comments: t(
                    "settings.mail.templates.event_info_mail.help_comments",
                ),
            };
            break;
        case "notification_order_received":
            cardTitle = "Notification Order Received";
            helpTexts = {
                subject:
                    "Subject for notification sent to staff when a new order is received",
                title: "Title for notification sent to staff when a new order is received",
                description:
                    "Description supports these variables: {{ order }} (Order information), {{order_date}} (Order creation date)",
                content:
                    "Content supports these variables: {{order}} (Order information), {{order_items}} (Table of order items)",
                comments: "Additional comments for this template",
            };
            break;
        case "invoice_reminder":
            cardTitle = "Invoice Reminder";
            helpTexts = {
                subject: "Subject for invoice reminder emails",
                title: "Title for invoice reminder emails",
                description:
                    "Description supports these variables: {{ invoice.invoice_number }}, {{ invoice.balance_display }}, {{ invoice.date_due }}, {{ days_overdue }}",
                content:
                    "Content supports these variables: {{ account.first_name }}, {{ invoice.invoice_number }}, {{ invoice.balance_display }}, {{ days_overdue }}, {{ invoice_url }}",
                comments: "Additional comments for this template",
            };
            break;
        case "invoice_email":
            cardTitle = "Invoice Email";
            helpTexts = {
                subject: "Subject for invoice emails",
                title: "Title for invoice emails",
                description:
                    "Description supports these variables: {{ invoice.invoice_number }}, {{ invoice.balance_display }}, {{ invoice.date_due }}",
                content:
                    "Content supports these variables: {{ account.first_name }}, {{ invoice.invoice_number }}, {{ invoice.balance_display }}, {{ invoice.date_due }}, {{ invoice_url }}, {{ organization.name }}",
                comments: "Additional comments for this template",
            };
            break;
        case "order_received":
            cardTitle = t("settings.mail.templates.order_received.title");
            helpTexts = {
                subject: t(
                    "settings.mail.templates.order_received.help_subject",
                ),
                title: t("settings.mail.templates.order_received.help_title"),
                description: t(
                    "settings.mail.templates.order_received.help_description",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                content: t(
                    "settings.mail.templates.order_received.help_content",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                comments: t(
                    "settings.mail.templates.order_received.help_comments",
                ),
            };
            break;
        case "recurring_payment_failed":
            cardTitle = t(
                "settings.mail.templates.recurring_payment_failed.title",
            );
            helpTexts = {
                subject: t(
                    "settings.mail.templates.recurring_payment_failed.help_subject",
                ),
                title: t(
                    "settings.mail.templates.recurring_payment_failed.help_title",
                ),
                description: t(
                    "settings.mail.templates.recurring_payment_failed.help_description",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                content: t(
                    "settings.mail.templates.recurring_payment_failed.help_content",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                comments: t(
                    "settings.mail.templates.recurring_payment_failed.help_comments",
                ),
            };
            break;
        case "system_footer":
            cardTitle = t("settings.mail.templates.system_footer.title");
            helpTexts = {
                subject: t(
                    "settings.mail.templates.system_footer.help_subject",
                ),
                title: t("settings.mail.templates.system_footer.help_title"),
                description: t(
                    "settings.mail.templates.system_footer.help_description",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                content: t(
                    "settings.mail.templates.system_footer.help_content",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                comments: t(
                    "settings.mail.templates.system_footer.help_comments",
                ),
            };
            break;
        case "trialpass_followup":
            cardTitle = t("settings.mail.templates.trialpass_followup.title");
            helpTexts = {
                subject: t(
                    "settings.mail.templates.trialpass_followup.help_subject",
                ),
                title: t(
                    "settings.mail.templates.trialpass_followup.help_title",
                ),
                description: t(
                    "settings.mail.templates.trialpass_followup.help_description",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                content: t(
                    "settings.mail.templates.trialpass_followup.help_content",
                    {
                        interpolation: { prefix: "%%", suffix: "%%" },
                    },
                ),
                comments: t(
                    "settings.mail.templates.trialpass_followup.help_comments",
                ),
            };
            break;
        default:
            cardTitle = t("settings.mail.templates.not_found.title");
            helpTexts = {
                subject: t("settings.mail.templates.not_found.help_subject"),
                title: t("settings.mail.templates.not_found.help_title"),
                description: t(
                    "settings.mail.templates.not_found.help_description",
                ),
                content: t("settings.mail.templates.not_found.help_content"),
                comments: t("settings.mail.templates.not_found.help_comments"),
            };
    }

    return {
        cardTitle: cardTitle,
        helpTexts: helpTexts,
    };
}
